import kebabCase from 'lodash/kebabCase';
import HintMessage from '../partials/static-field-hint-message.vue';
import ErrorMessage from '../partials/static-field-error-message.vue';

export default {
  model: {
    prop: 'fieldValue',
    event: 'change',
  },

  components: {
    HintMessage,
    ErrorMessage,
  },

  props: {
    fieldValue: {
      type: [String, Number, Boolean, Object, Array, File],
      default: null,
    },
    question: {
      type: Object,
      default: () => {},
    },
    manualValidate: {
      type: Boolean,
      default: false,
    },
    hint: {
      default: null,
      type: Object,
    },
    error: {
      default() {
        return {
          status: '',
          message: '',
          errors: [],
        };
      },
      type: Object,
    },
    hasAutofocus: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isBlurred: false,
    };
  },

  computed: {
    options() {
      if (!this.question.options) return null;

      return this.question.options.map((option) => {
        if ((typeof option === 'object' && option !== null)) return option;

        return {
          id: option,
          label: option,
        };
      });
    },
    fieldQuestionId() {
      return `field-${this.question.id}`;
    },
    fieldHasError() {
      if (this.error.invalid && this.isBlurred) return true;

      return this.error.errors.some((error) => {
        return !error.status && this.manualValidate;
      });
    },
  },

  mounted() {
    this.setInitialValue();
    this.autoFocusField();
  },

  methods: {
    setInitialValue() {
      if (this.question.initialVal) {
        this.$emit('change', this.question.initialVal);
      }
    },
    autoFocusField() {
      if (!this.hasAutofocus) return;

      // console.log(this.$refs);

      let target = this.$refs['auto-focus-target'];

      if (Array.isArray(this.$refs['auto-focus-target'])) {
        target = this.$refs['auto-focus-target'][0]; // eslint-disable-line
      }

      target.focus();
    },
    generateSafeId(fieldQuestionId, optionId, suffix) {
      return kebabCase(`${fieldQuestionId}-${optionId}-${suffix}`);
    },
    getFieldQuestionId() {
      return this.fieldQuestionId;
    },
  },
};
